export default __webpack_public_path__ + "static/bg-2f8d8ce1b143009142c8ae4cfd71461c.png";